import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const Section = () => {
  const [sections, setSections] = useState([]);
  const [schools, setSchools] = useState([]);
  const [standards, setStandards] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // "add" or "edit"
  const [adminSelectedSchoolId, setAdminSelectedSchoolId] = useState(null);
  const [currentItem, setCurrentItem] = 
      useState({ id: 0, name: "", schoolId: adminSelectedSchoolId, standardId: "", inTake: 0 });

  useEffect(() => {
    fetchSections();
    fetchAdminSchoolId();    
  }, []);  

  const fetchAdminSchoolId = async () => {
    try {
      const url = `${baseUrl}/api/Admin/GetAdminByUserId?id=${localStorage.getItem("userID")}`;
      const response = await axios.get(url);
      if (response && response.data && response.data) 
      {
        setAdminSelectedSchoolId(response.data);
        fetchStandardsBySchool(response.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  // Fetch sections
  const fetchSections = async () => {
    try {
      const url =
      localStorage.getItem("Role") === "SUPERADMIN"
          ? `${baseUrl}/api/SectionMaster/GetSectionDetails`
          : `${baseUrl}/api/SectionMaster/GetSectionMastersByAdmin?AdminId=${localStorage.getItem(
              "userID"
            )}`;
      const response = await axios.get(url);
      setSections(response.data);
    } catch (error) {
      toast.error("Failed to fetch sections");
    }
  };

  // Fetch standards by selected schoolId
  const fetchStandardsBySchool = async (schoolId) => {
    try {
      const response = await axios.get(`${baseUrl}/api/StandardMaster/GetStandardBySchool?id=${schoolId}`);
      setStandards(response.data);
    } catch (error) {
      toast.error("Failed to fetch standards");
    }
  };

  const handleAdd = () => {
    setCurrentItem({ id: 0, name: "", schoolId: adminSelectedSchoolId, standardId: "" });
    setModalMode("add");
    setShowModal(true);
  };

  const handleEdit = (item) => {
    
    //setCurrentItem(item);
    setCurrentItem({
      id: item.sectionId, // id corresponds to sectionId in the JSON
      name: item.sectionName,
      schoolId: adminSelectedSchoolId,
      standardId: item.standardId,
      inTake: item.intake, // Assuming inTake is part of the item object
    });
    setModalMode("edit");
    setShowModal(true);
    fetchStandardsBySchool(adminSelectedSchoolId); // Fetch standards for the selected school when editing
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        await axios.delete(`${baseUrl}/api/SectionMaster/${id}`);
        toast.success("Item deleted successfully");
        fetchSections();
      } catch (error) {
        toast.error("Failed to delete item");
      }
    }
  };

  const handleSave = async () => {
    try {
      if (modalMode === "add") {
        await axios.post(`${baseUrl}/api/SectionMaster`, { ...currentItem, id: 0 });
        toast.success("Item added successfully");
      } else {
        await axios.put(`${baseUrl}/api/SectionMaster/${currentItem.id}`, currentItem);
        toast.success("Item updated successfully");
      }
      fetchSections();
      setShowModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save item");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Section</h2>
          <Button variant="primary" onClick={handleAdd}>Add New</Button>
        </div>
        <table className="table table-bordered table-striped">
        <thead className="thead-dark">
            <tr>
            <th>#</th>
            {/* <th>School</th> */}
              <th>Section</th>               
              <th>Standard</th>
              <th>InTake</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sections.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                {/* <td>{item.schoolName}</td> */}
                <td>{item.sectionName}</td>                
                <td>{item.standardName}</td>
                <td>{item.intake}</td>
                <td>
                  <Button variant="warning" onClick={() => handleEdit(item)} className="mr-2">Edit</Button>
                  <Button variant="danger" onClick={() => handleDelete(item.sectionId)}>Delete</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{modalMode === "add" ? "Add New" : "Edit"} Section</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* <Form.Group controlId="formSchool">
                <Form.Label>School</Form.Label>
                <Form.Control
                  as="select"
                  value={currentItem.schoolId}
                  onChange={handleSchoolChange}
                >
                  <option value="">Select School</option>
                  {schools.map((school) => (
                    <option key={school.schoolId} value={school.schoolId}>
                      {school.schoolOrCollegeName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group> */}

              <Form.Group controlId="formStandard">
                <Form.Label>Standard</Form.Label>
                <Form.Control
                  as="select"
                  value={currentItem.standardId}
                  onChange={(e) => setCurrentItem({ ...currentItem, standardId: e.target.value })}
                  disabled={!currentItem.schoolId}
                >
                  <option value="">Select Standard</option>
                  {standards.map((standard) => (
                    <option key={standard.id} value={standard.id}>
                      {standard.standardName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  value={currentItem.name}
                  onChange={(e) => setCurrentItem({ ...currentItem, name: e.target.value })}
                />
              </Form.Group>

              <Form.Group controlId="formInTake">
                <Form.Label>InTake</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter inTake"
                  value={currentItem.inTake}
                  onChange={(e) => setCurrentItem({ ...currentItem, inTake: parseInt(e.target.value) })}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
            <Button variant="primary" onClick={handleSave}>{modalMode === "add" ? "Add" : "Update"}</Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Section;
